import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useCallback } from 'react';
import { CarouselContainer, Carousel, CarouselTrack, CarouselImage, CarouselOverlay, CarouselSlide, CarouselBtn, CarouselIndicators, Indicator } from './partials';
export var ImagesCarousel = function ImagesCarousel(_ref) {
  var images = _ref.images,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    _ref$interval = _ref.interval,
    interval = _ref$interval === void 0 ? 4000 : _ref$interval,
    _ref$showDots = _ref.showDots,
    showDots = _ref$showDots === void 0 ? true : _ref$showDots,
    _ref$showArrows = _ref.showArrows,
    showArrows = _ref$showArrows === void 0 ? true : _ref$showArrows;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    autoplayInterval = _useState4[0],
    setAutoplayInterval = _useState4[1];
  var nextSlide = function nextSlide() {
    setCurrentIndex(function (prevIndex) {
      return (prevIndex + 1) % images.length;
    });
  };
  var prevSlide = function prevSlide() {
    setCurrentIndex(function (prevIndex) {
      return (prevIndex - 1 + images.length) % images.length;
    });
  };
  var goToSlide = function goToSlide(index) {
    setCurrentIndex(index);
  };
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    touchStartX = _useState6[0],
    setTouchStartX = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    touchEndX = _useState8[0],
    setTouchEndX = _useState8[1];
  var handleTouchStart = function handleTouchStart(e) {
    setTouchStartX(e.touches[0].clientX);
  };
  var handleTouchMove = function handleTouchMove(e) {
    setTouchEndX(e.touches[0].clientX);
  };
  var handleTouchEnd = function handleTouchEnd() {
    if (!touchStartX || !touchEndX) return;
    var delta = touchStartX - touchEndX;
    var minSwipeDistance = 50;
    if (delta > minSwipeDistance) nextSlide();else if (delta < -minSwipeDistance) prevSlide();
    setTouchStartX(null);
    setTouchEndX(null);
  };
  var resetAutoplay = function resetAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      setAutoplayInterval(null);
    }
    var newAutoplay = setInterval(function () {
      return nextSlide();
    }, interval);
    setAutoplayInterval(newAutoplay);
  };
  useEffect(function () {
    if (!autoplay) return;
    resetAutoplay();
    return function () {
      if (autoplayInterval) clearInterval(autoplayInterval);
    };
  }, [currentIndex, images.length]);
  var handleKeyDown = useCallback(function (event) {
    if (event.key === 'ArrowRight') {
      nextSlide();
    } else if (event.key === 'ArrowLeft') {
      prevSlide();
    }
  }, []);
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
  return React.createElement(CarouselContainer, null, React.createElement(Carousel, {
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd
  }, React.createElement(CarouselTrack, {
    style: {
      transform: "translateX(-".concat(currentIndex * 100, "%)")
    }
  }, images.map(function (image, index) {
    return React.createElement(CarouselSlide, {
      key: index
    }, React.createElement(CarouselImage, {
      src: image.src,
      alt: image.title,
      loading: "lazy"
    }), React.createElement(CarouselOverlay, null, image.title && React.createElement("h3", null, image.title), image.description && React.createElement("p", null, image.description)));
  })), showArrows && images.length > 1 && React.createElement(React.Fragment, null, React.createElement(CarouselBtn, {
    onClick: prevSlide,
    className: "prev"
  }, "\u2039"), React.createElement(CarouselBtn, {
    onClick: nextSlide,
    className: "next"
  }, "\u203A"))), showDots && images.length > 1 && React.createElement(CarouselIndicators, null, images.map(function (image, index) {
    return React.createElement(Indicator, {
      key: index,
      className: index === currentIndex ? 'active' : '',
      onClick: function onClick() {
        return goToSlide(index);
      }
    });
  })));
};